import { render, staticRenderFns } from "./SpecialistLicense.vue?vue&type=template&id=1f44c23b&scoped=true"
import script from "./SpecialistLicense.vue?vue&type=script&lang=js"
export * from "./SpecialistLicense.vue?vue&type=script&lang=js"
import style0 from "./SpecialistLicense.vue?vue&type=style&index=0&id=1f44c23b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f44c23b",
  null
  
)

export default component.exports